import { useLanguage } from './LanguageContext';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axiosInstance from './axiosInstance'; // ✅ Import axiosInstance
import Login from './components/Login';
import AdminDashboard from './components/AdminDashboard';
import PlayerList from './components/PlayerList';
import ManualBans from './components/ManualBans';
import BannedPlayers from './components/BannedPlayers';
import ProtectedRoute from './components/ProtectedRoute';
import Unauthorized from './components/Unauthorized';
import NavBar from './components/NavBar';
import BrandingSettings from './components/BrandingSettings';

function App() {
  const { t } = useLanguage();
  const [role, setRole] = useState(null); // Track the user's role
  const [isLoading, setIsLoading] = useState(true); // ✅ Add isLoading

  useEffect(() => {
    axiosInstance.get("/api/check-auth") // ✅ Replaces fetch with axiosInstance
      .then((response) => {
        if (response.data.success) {
          setRole(response.data.role);
          console.log('App role:', response.data.role); // Debug role
        }
      })
      .catch((error) => console.error('Error fetching user role:', error))
      .finally(() => setIsLoading(false)); // ✅ Ensure loading is finished
  }, []);
  
  // ✅ Show a loading message while checking authentication
  if (isLoading) {
    return <div className="loading">{t("Loading...")}</div>;
  }
  
  return (
    <div className="App">
      <Router>
        <NavBar role={role} setRole={setRole} /> {/* Add NavBar */}
          <Routes>
            <Route path="/appearance" element={<ProtectedRoute requiredRole={['superadmin']}><BrandingSettings /></ProtectedRoute>} />
            <Route path="/login" element={<Login setRole={setRole} />} />

            {/* ✅ Superadmin can access everything */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute requiredRole={["admin", "superadmin"]}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/player-list"
              element={
                <ProtectedRoute requiredRole={["moderator", "admin", "superadmin"]}>
                  <PlayerList serverId={1} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/banned-players"
              element={
                <ProtectedRoute requiredRole={["moderator", "admin", "superadmin"]}>
                  <BannedPlayers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/manual-bans" // ✅ New Route
              element={
                <ProtectedRoute requiredRole={["moderator", "admin", "superadmin"]}>
                  <ManualBans />
                </ProtectedRoute>
              }
            />

            <Route path="/unauthorized" element={<Unauthorized />} />
            
            {/* ✅ Superadmin gets redirected properly */}
            <Route
              path="/"
              element={
                role === 'superadmin' ? (
                  <Navigate to="/admin" replace />
                ) : role === 'admin' || role === 'moderator' ? (
                  <Navigate to="/player-list" replace />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
            <Route path="*" element={<h1>{t("404: Page Not Found")}</h1>} />
          </Routes>
      </Router>
    </div>
  );
}

export default App;
